// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1bc94f5e","453":"0407569a","667":"28a04c5c"}[chunkId] + ".chunk.js";
};